import httpClient from '@/api/http-client';

const endpoint = 'api/permit-prices';

const permitPriceService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  search: (query) => httpClient.get(`${endpoint}/find/${query}`),

  create: (permitPrice) => httpClient.post(`${endpoint}`, permitPrice),

  update: (permitPrice) => httpClient.put(`${endpoint}/${permitPrice.id}`, permitPrice),

  delete: (permitPrice) => httpClient.delete(`${endpoint}/${permitPrice.id}`),
};

export default permitPriceService;
